document.addEventListener('DOMContentLoaded', function() {

    // document.querySelector('.js-drawer-open-cart').click(startCountdown)

      // Get the countdown element and initial time
      var countdownElement = document.querySelector('.countdown-timer');
      var timeLeft = parseInt(countdownElement.getAttribute('data-time-left')); // In seconds
  
      // Update the countdown display initially
      function updateCountdownDisplay() {
          var minutes = Math.floor(timeLeft / 60);
          var seconds = timeLeft % 60;
          if (seconds < 10) seconds = '0' + seconds; // Padding for single digit seconds
          document.getElementById('time-left').textContent = minutes + ':' + seconds;
      }
  
      // Start the countdown
      function startCountdown() {
          var countdownInterval = setInterval(function() {
              timeLeft--;
              updateCountdownDisplay();
  
              // Stop the countdown when timeLeft reaches zero
              if (timeLeft <= 0) {
                  clearInterval(countdownInterval);
                  countdownElement.textContent = "YOUR ORDER IS NO LONGER RESERVED";
              }
          }, 1000); // Update every second
      }
  
      // Initialize the display and start the countdown
      updateCountdownDisplay();
      startCountdown();
});